export const SHOW_ALERT_MESSAGE = 'alert/SHOW_ALERT_MESSAGE'
export const HIDE_ALERT_MESSAGE = 'alert/HIDE_ALERT_MESSAGE'
